import { render, staticRenderFns } from "./CoursesApproval.vue?vue&type=template&id=5d395bdf&scoped=true"
import script from "./CoursesApproval.vue?vue&type=script&lang=js"
export * from "./CoursesApproval.vue?vue&type=script&lang=js"
import style0 from "./CoursesApproval.vue?vue&type=style&index=0&id=5d395bdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d395bdf",
  null
  
)

export default component.exports